const pendingStatus = ['waiting', 'retrying', 'processing'];
const finishedStatus = ['finished', 'failed'];

export const getJobs = (state, jobName) => state.queue.jobs.filter(job => job.name === jobName);

export const getPendingJobs = (state, jobName) =>
  state.queue.jobs.filter(job => job.name === jobName && pendingStatus.includes(job.status));

export const getFinishedJobs = (state, jobName) =>
  state.queue.jobs.filter(job => job.name === jobName && finishedStatus.includes(job.status));
